import RestService from "./RestService";



export default class News extends RestService {
    constructor() {
        super('/api/onboarding' )
    }


    /**
     * Get the cards for the onboarding
     * @param {string} language - The language to get the cards for
     * @returns {Promise<Array<Object>>} - The cards for the onboarding
     */
    cards(language){
        return this.get(`${this.baseUrl}/cards/${language}`)
    }

    memberOnboardingCards(language){
        return this.get(`/api/members/onboarding/cards/${language}`)
    }

    shoppingBossOnboarding(language){
        return this.get(`/api/lifeapp/promos/superapp`)
    }

}
